import { render } from "./DataTable.vue?vue&type=template&id=a40d6de2"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=a40d6de2&lang=css"
script.render = render

export default script